import { CancelOutlined } from "@mui/icons-material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

function BWCMemberSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();
  const [memberNumber, setMemberNumber] = useState(props.memberNumber || "");
  const [firstName, setFirstName] = useState(props.firstName || "");
  const [lastName, setLastName] = useState(props.lastName || "");
  const [phoneNumber, setPhoneNumber] = useState(props.phoneNumber || "");

  const [searchTypes, setSearchTypes] = useState([
    { key: "MEMBER_NUMBER", value: t("BWC.ContractSearch.DropdownOptions1") },
    { key: "NAME", value: t("BWC.ContractSearch.DropdownOptions2") },
  ]);

  const [selectedSearchTypes, setSelectedSearchTypes] = useState("NAME");

  useEffect(() => {
    devLog(selectedSearchTypes);
    setMemberNumber(memberNumber);
    setFirstName(firstName);
    setLastName(lastName);
    setPhoneNumber(phoneNumber);
  }, [selectedSearchTypes]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        memberNumber: memberNumber,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        searchType: selectedSearchTypes,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        memberNumber: memberNumber,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        searchType: selectedSearchTypes,
      });
    }
    return false;
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key == selectedSearchTypes)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchTypes}
                    onClick={(e) => setSelectedSearchTypes(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/*Member Number*/}
          {selectedSearchTypes === "MEMBER_NUMBER" && (
            <>
              <div className="group-1">
                <div className="label">{t("BWC.ContractSearch.DropdownOptions1")}:</div>
                <input
                  type="text"
                  placeholder={t("BWC.ContractSearch.DropdownOptions1")}
                  name="memberNumber"
                  className="input form-control required"
                  value={memberNumber}
                  onChange={(e) => {
                    setMemberNumber(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/*First Name*/}
          {selectedSearchTypes === "NAME" && (
            <>
              <div className="group-1">
                <div className="label">{t("BWC.ContractSearch.DropdownSubOptions1")}:</div>
                <input
                  type="text"
                  placeholder={t("BWC.ContractSearch.DropdownSubOptions1")}
                  name="firstName"
                  className="input form-control required"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {/*Last Name*/}
          {selectedSearchTypes === "NAME" && (
            <>
              <div className="group-1">
                <div className="label">{t("BWC.ContractSearch.DropdownSubOptions2")}:</div>
                <input
                  type="text"
                  placeholder={t("BWC.ContractSearch.DropdownSubOptions2")}
                  name="lastName"
                  className="input form-control required"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default BWCMemberSearchForm;
